import Image from 'next/image'

import dimensions from '../../../utils/dimensions'
import { CoverEl } from '../elements'
import ArtistInfoStore from '../stores/artist-info-store'

const Cover = () => {
  const {
    data: {
      profile: { cover },
    },
  } = ArtistInfoStore.useContainer()

  return (
    <CoverEl>
      {cover && (
        <Image
          height={dimensions.dw(100)}
          priority
          quality={50}
          src={cover}
          width={dimensions.dw(100)}
        />
      )}
    </CoverEl>
  )
}

export default Cover
